// Mystery-gang style default avatars for the Who's In board — original
// 1970s-cartoon artwork (generated, not licensed characters). Used only until
// a user uploads their own photo; the pick is deterministic per person so the
// same face follows them across sessions.
const BASE = "https://static.prod-images.emergentagent.com/jobs/cac67236-8acf-4a22-94ee-7f35274d9105/images";

export const MYSTERY_AVATARS = [
  `${BASE}/72eb389901ea6cc2dcb13d21bf4c99438725854327a2687a396163e8c6fb5037.jpeg`, // great dane
  `${BASE}/a7302cca327744ed93a2fadd1ebf945d67932738fdd3c8ee3504033466b1b44f.jpeg`, // scruffy snack guy
  `${BASE}/fed18cd5f27396694dd509e8117dafa6358045b7185eb8646875f8075c86f7de.jpeg`, // ascot preppy
  `${BASE}/e15b9eea44ce05c36ce65d7bda3a7eb299032df0a348ce550251d12263925a54.jpeg`, // redhead in orange
  `${BASE}/442cc786ff790ae755541f771bdd56406ba92d8536bff62d493e7b817137392b.jpeg`, // bookish glasses
  `${BASE}/8d8c5b6f2dc1914c16787de35e1d1faf9db874d4c468f6f5e6ecd6a1a0233e35.jpeg`, // cheeky puppy
  `${BASE}/acf887696881012eb9e4a55d08bffa0bf0b8b0caeda0644145c638ad2c686a2a.jpeg`, // silly ghost
  `${BASE}/ea67df2989bded7c0f7f54d8dd47b1b8e05f618ed00818d33d4fb1234c08c3c9.jpeg`, // groovy van
];

export function mysteryAvatarFor(seed = "") {
  const key = (seed || "conduit").trim().toLowerCase();
  let h = 5381;
  for (let i = 0; i < key.length; i += 1) h = ((h * 33) ^ key.charCodeAt(i)) >>> 0;
  return MYSTERY_AVATARS[h % MYSTERY_AVATARS.length];
}
